import { Directive, HostListener, Output, EventEmitter, ElementRef, Renderer2 } from '@angular/core';

@Directive({
    selector: '[fileDrop]'
})
export class FileDropDirective {
    @Output() fileDropped = new EventEmitter<FileList>();
    @Output() hovering = new EventEmitter<boolean>();

    constructor(private el: ElementRef, private renderer: Renderer2) { }

    private eatEvent(ev) {
        ev.preventDefault();
        ev.stopPropagation();
    }

    private setHover(flag: boolean) {
        this.hovering.emit(flag);
    }

    private checkTarget(event: any) {
        return event.target == this.el.nativeElement ||
            event.target.classList.contains('drop-target');
    }

    private setDrag(flag: boolean) {
        if (flag) {
            this.renderer.addClass(this.el.nativeElement, 'dragover');
        } else {
            this.renderer.removeClass(this.el.nativeElement, 'dragover');
        }
    }

    private endDrag(event) {
        this.eatEvent(event);
        this.setHover(false);
        this.setDrag(false);
    }

    @HostListener('dragenter', ['$event']) onDragEnter(event: any) {
        this.eatEvent(event);
        this.setHover(true);
        this.setDrag(true);
    }

    @HostListener('dragover', ['$event']) onDragOver(event: any) {
        this.eatEvent(event);
    }

    @HostListener('dragend', ['$event']) onDragEnd(event: any) {
        this.endDrag(event);
    }

    @HostListener('dragleave', ['$event']) onDragLeave(event: any) {
        if (this.checkTarget(event)) {
            this.endDrag(event);
        }
    }

    @HostListener('drop', ['$event']) onDrop(event: any) {
        this.endDrag(event);

        const files: FileList = event.dataTransfer.files;
        if (files.length > 0) {
            this.fileDropped.emit(files);
        }
    }
}
